// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

// console.log('Hello from application.js');

require('@rails/ujs').start();
require('turbolinks').start();
require('@rails/activestorage').start();

import '../stylesheets/application.scss';
import 'bootstrap';
import 'jquery';
import 'popper.js';

// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)

import I18n from 'i18n-js';
window.I18n = I18n;

// document.addEventListener('turbolinks:load', () => {
// 	$('[data-toggle="tooltip"]').tooltip();
// });


// Support component names relative to this directory:
var componentRequireContext = require.context('components', true);
var ReactRailsUJS = require('react_ujs');
ReactRailsUJS.useContext(componentRequireContext);
